module.exports = __webpack_public_path__ + "img/ibs_03.3f8e41d0.png";